var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "checkbox"
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        staticClass: "form-control",
        attrs: {
          name: _vm.field,
          placeholder: _vm.placeholder,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          type: "checkbox"
        },
        domProps: {
          checked: Array.isArray(_vm.model)
            ? _vm._i(_vm.model, null) > -1
            : _vm.model
        },
        on: {
          change: function($event) {
            var $$a = _vm.model,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.model = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.model = $$c
            }
          }
        }
      })
    : _vm.type === "radio"
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        staticClass: "form-control",
        attrs: {
          name: _vm.field,
          placeholder: _vm.placeholder,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          type: "radio"
        },
        domProps: { checked: _vm._q(_vm.model, null) },
        on: {
          change: function($event) {
            _vm.model = null
          }
        }
      })
    : _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        staticClass: "form-control",
        attrs: {
          name: _vm.field,
          placeholder: _vm.placeholder,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          type: _vm.type
        },
        domProps: { value: _vm.model },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.model = $event.target.value
          }
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }